import { createContext, useContext, useState, useCallback } from 'react';
import { useNewsData } from './NewsDataContext';
import WhatsAppSuggestSheet from '../components/WhatsAppSuggestSheet';
import { trackEvent } from '../utils/analytics';

const WhatsAppHelpContext = createContext({
  openWhatsAppHelp: () => {},
});

export function WhatsAppHelpProvider({ children }) {
  const { homeFeed } = useNewsData();
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('app');

  const openWhatsAppHelp = useCallback((placementId = 'app') => {
    trackEvent('contact_whatsapp_open', { placement: placementId });
    setPlacement(placementId);
    setOpen(true);
  }, []);

  return (
    <WhatsAppHelpContext.Provider value={{ openWhatsAppHelp }}>
      {children}
      <WhatsAppSuggestSheet
        open={open}
        onClose={() => setOpen(false)}
        placement={placement}
        waTemplates={homeFeed.waTemplates}
      />
    </WhatsAppHelpContext.Provider>
  );
}

export function useWhatsAppHelp() {
  return useContext(WhatsAppHelpContext);
}
